<template>
  <div>
    <v-container>
      <top-confirmation-menu color="#E57373" />
      <top-written-survey-menu color="#64B5F6" />
      <v-row style="min-width: 980px; max-width: 1200px">
        <v-col
          offset="2"
          cols="2"
          class="text-left">
          <v-chip
            dark
            color="default"
            large
            class="step-mark1 font-weight-bold">
            &nbsp;現地における目視調査&nbsp;
          </v-chip>
        </v-col>
        <v-col cols="10"></v-col>
      </v-row>
      <top-field-survey-index color="green" />
      <top-detail-menu color="#FBC02D" />
      <top-report-menu color="#90A4AE" />
    </v-container>
  </div>
</template>

<script>
import TopConfirmationMenu from './Top/ConfirmationMenu'
import TopWrittenSurveyMenu from './Top/WrittenSurveyMenu'
import TopFieldSurveyIndex from './Top/FieldSurveyMenu'
import TopDetailMenu from './Top/DetailMenu'
import TopReportMenu from './Top/ReportMenu'

export default {
  name: 'Index',
  components: {
    TopReportMenu,
    TopDetailMenu,
    TopFieldSurveyIndex,
    TopWrittenSurveyMenu,
    TopConfirmationMenu,
  },
  methods: {
    onUserManagementClicked() {
      this.$router.push({ name: 'userIndex' })
    },
  },
}
</script>

<style scoped>
.step-mark1 {
  padding-right: 180px;
  margin-left: -105px;
  width: 200px;
}
</style>
